
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.5 11a.5.5 0 01-.354-.146l-5-5A.505.505 0 010 5.5a.5.5 0 01.146-.353l5-5a.5.5 0 01.707.708L1.207 5.5l4.646 4.647A.5.5 0 015.5 11z"}}),_c('path',{attrs:{"d":"M14.5 24h-11a.5.5 0 010-1h11a8.5 8.5 0 000-17H.5a.5.5 0 010-1h14a9.5 9.5 0 010 19z"}})])
          )
        }
      }
    